import axios from 'axios';

export default {
    namespaced: true,
    state: {
        items: [],
        ajaxRequest: null,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
    },
    getters: {
        getItems(state) {
            return state.items;
        },
    },
    actions: {
        list(context, params) {
            // cancel  previous ajax if exists
            if (context.state.ajaxRequest) {
                context.state.ajaxRequest.cancel();
            }

            // creates a new token for upcomming ajax (overwrite the previous one)
            context.state.ajaxRequest = axios.CancelToken.source();

            return axios
                .post(
                    '/api/search',
                    {
                        searchQuery: params.searchQuery,
                    },
                    { cancelToken: context.state.ajaxRequest.token }
                )
                .then((response) => {
                    context.commit('setItems', response.data.items);

                    return Promise.resolve(response);
                })
                .catch(function (err) {
                    if (axios.isCancel(err)) {
                        console.log('Previous request canceled, new request is send', err.message);
                    } else {
                        // handle error
                    }
                });
        },
    },
};
